
import { Vue, Component, Prop } from 'vue-property-decorator';
import { OrderInfo } from '@/features/shipment/types';
import { truncateText, useFormatTimestamp } from '@/features/common/helpers';

@Component
export default class OrdersListingItem extends Vue {
  @Prop({ required: true }) item!: OrderInfo;

  private useFormatTimestamp = useFormatTimestamp;

  private truncateText = truncateText;

  get fulfillmentStatus(): { label: string, mark: string, text: string } {
    switch (this.item.fulfillmentStatus) {
      case 'fulfilled':
        return {
          label: 'Fulfilled',
          mark: 'marker--fulfilled',
          text: 'marker--fulfilled-text',
        };
      case 'partial':
        return {
          label: 'Partial',
          mark: 'marker--partial',
          text: 'marker--partial-text',
        };

      default:
        return {
          label: 'Unfulfilled',
          mark: 'marker--unfulfilled',
          text: 'marker--unfulfilled-text',
        };
    }
  }

  get orderItemInPlainText(): string {
    const {
      date,
      customer,
      count,
    } = this.item;

    const dateFormatted = date ? `${this.useFormatTimestamp(date)}, ` : '';
    const customerFormatted = customer ? `${customer}, ` : '';
    const countFormatted = count ? this.$tc('shipment.importShipment.ordersListing.table.tbody.nItems', count) : '';

    return `${dateFormatted}${customerFormatted}${countFormatted}`;
  }
}
